// Mobile Group Flickity Slider

class GroupMobileSlider {
  constructor() {
    this.sliders = new Map();
    this.mediaQuery = window.matchMedia('(max-width: 749px)');

    this.init();

    this.mediaQuery.addEventListener('change', () => {
      this.refreshAll();
    });
  }

  init() {
    document
      .querySelectorAll('[data-mobile-slider="true"]')
      .forEach((container) => {
        this.setup(container);
      });
  }

  setup(container) {
    if (!this.mediaQuery.matches) return;

    if (this.sliders.has(container)) return;

    const slides = Array.from(
      container.querySelectorAll(':scope > .group-block')
    );

    if (slides.length < 2) return;

    const initialIndex = Math.floor(slides.length / 2);

    const flkty = new Flickity(container, {
      cellSelector: '.group-block',

      cellAlign: 'center',

      // Infinite loop
      wrapAround: true,

      // Start from the CENTER slide
      initialIndex: initialIndex,

      // Show neighboring slides
      contain: false,

      // Mobile interaction
      draggable: true,

      // Smooth movement
      selectedAttraction: 0.08,
      friction: 0.8,

      // Controls
      prevNextButtons: false,
      pageDots: true,

      // Images
      imagesLoaded: true,

      // Keep height
      adaptiveHeight: false,

      resize: true
    });

    this.sliders.set(container, {
      flkty,
      slides
    });
  }

  destroy(container) {
    const instance = this.sliders.get(container);

    if (!instance) return;

    instance.flkty.destroy();

    this.sliders.delete(container);
  }

  refreshAll() {
    document
      .querySelectorAll('[data-mobile-slider="true"]')
      .forEach((container) => {
        if (this.mediaQuery.matches) {
          this.setup(container);
        } else {
          this.destroy(container);
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof Flickity === 'undefined') {
    console.warn('Flickity is not loaded.');
    return;
  }

  new GroupMobileSlider();
});

// class GroupMobileSlider {
//   constructor() {
//     this.sliders = new Map();

//     this.mediaQuery = window.matchMedia('(max-width: 749px)');

//     this.init();

//     this.mediaQuery.addEventListener('change', () => {
//       this.refreshAll();
//     });
//   }

//   init() {
//     document
//       .querySelectorAll('[data-mobile-slider="true"]')
//       .forEach((container) => {
//         this.setup(container);
//       });
//   }

//   setup(container) {
//     if (!this.mediaQuery.matches) return;

//     if (this.sliders.has(container)) return;

//     const slides = Array.from(container.children).filter(
//       (child) =>
//         !child.matches(
//           '.swiper-button-prev, .swiper-button-next, .swiper-pagination'
//         )
//     );

//     if (slides.length < 2) return;

//     const wrapper = document.createElement('div');
//     wrapper.className = 'swiper-wrapper';

//     slides.forEach((slide) => {
//       slide.classList.add('swiper-slide');
//       wrapper.appendChild(slide);
//     });

//     container.appendChild(wrapper);
//     container.classList.add('swiper');

//     const swiper = new Swiper(container, {
//       slidesPerView: 1,
//       centeredSlides: true,
//       spaceBetween: 12,

//       speed: 600,
//       loop: true,
//       grabCursor: true,

//       watchOverflow: true,

//       observer: true,
//       observeParents: true,

//       pagination: {
//         el: container.querySelector('.swiper-pagination'),
//         clickable: true,
//       },

//       navigation: {
//         nextEl: container.querySelector('.swiper-button-next'),
//         prevEl: container.querySelector('.swiper-button-prev'),
//       },
//     });

//     this.sliders.set(container, {
//       swiper,
//       wrapper,
//       slides,
//     });
//   }

//   destroy(container) {
//     const instance = this.sliders.get(container);

//     if (!instance) return;

//     instance.swiper.destroy(true, true);

//     instance.slides.forEach((slide) => {
//       slide.classList.remove('swiper-slide');
//       container.appendChild(slide);
//     });

//     instance.wrapper.remove();

//     container.classList.remove('swiper');

//     this.sliders.delete(container);
//   }

//   refreshAll() {
//     document
//       .querySelectorAll('[data-mobile-slider="true"]')
//       .forEach((container) => {
//         if (this.mediaQuery.matches) {
//           this.setup(container);
//         } else {
//           this.destroy(container);
//         }
//       });
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   if (typeof Swiper === 'undefined') {
//     console.warn('Swiper is not loaded.');
//     return;
//   }

//   new GroupMobileSlider();
// });